// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__TJt_J","blocks":"style_blocks__woTwy","booking":"style_booking___V1Lm","mobileBooking":"style_mobileBooking__re6b0"};